var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { width: "100%" }, attrs: { "pa-0": "" } },
    [
      _vm._l(_vm.services, function (service) {
        return _c("ServiceItem", {
          key: service.id,
          attrs: { service: service },
        })
      }),
      _vm._v(" "),
      _vm.services.length == 0
        ? _c("v-container", [
            _c(
              "p",
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "pr-2",
                    staticStyle: { "line-height": "19px" },
                    attrs: { color: "info" },
                  },
                  [_vm._v("error_outline")]
                ),
                _vm._v(
                  "\n      This place is empty. Register a service and it will show up here!\n    "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }